document.addEventListener('DOMContentLoaded', function () {
    
    /*
    * Navigation par pagination (pas par date)
    */
    const navigation = document.querySelector('.navigation');
    const leftWrapper = document.querySelector('.screen-left .table-wrapper');
    const planningTable = leftWrapper ? leftWrapper.querySelector('table.planning-table') : null;
    
    if (navigation && leftWrapper && planningTable) {
        let currentPage = 0;
        let rowsPerPage = 0;
        const allRows = Array.from(planningTable.querySelectorAll('tbody tr'));
        const thead = planningTable.querySelector('thead');
        
        // Calculer combien de lignes peuvent tenir à l'écran
        function calculateRowsPerPage() {
            // Réinitialiser l'affichage
            allRows.forEach(r => r.style.display = '');
            
            const availableHeight = leftWrapper.clientHeight - (thead ? thead.offsetHeight : 0);
            let usedHeight = 0;
            let count = 0;
            
            for (const row of allRows) {
                const rowHeight = row.offsetHeight;
                if (usedHeight + rowHeight <= availableHeight) {
                    usedHeight += rowHeight;
                    count++;
                } else {
                    break;
                }
            }
            
            rowsPerPage = Math.max(1, count);
            return rowsPerPage;
        }
        
        // Afficher la page actuelle
        function showCurrentPage() {
            const startIndex = currentPage * rowsPerPage;
            const endIndex = startIndex + rowsPerPage;
            
            allRows.forEach((row, index) => {
                if (index >= startIndex && index < endIndex) {
                    row.style.display = '';
                } else {
                    row.style.display = 'none';
                }
            });
            
            // Gérer l'état des boutons
            const prevButton = document.querySelector('.nav-button.prev');
            const nextButton = document.querySelector('.nav-button.next');
            
            if (prevButton) {
                prevButton.style.opacity = currentPage === 0 ? '0.3' : '1';
                prevButton.style.cursor = currentPage === 0 ? 'default' : 'pointer';
            }
            
            if (nextButton) {
                const hasNextPage = endIndex < allRows.length;
                nextButton.style.opacity = hasNextPage ? '1' : '0.3';
                nextButton.style.cursor = hasNextPage ? 'pointer' : 'default';
            }
        }
        
        // Initialiser
        calculateRowsPerPage();
        showCurrentPage();
        
        // Bouton précédent
        document.querySelector('.nav-button.prev').addEventListener('click', () => {
            if (currentPage > 0) {
                currentPage--;
                showCurrentPage();
            }
        });

        // Bouton suivant
        document.querySelector('.nav-button.next').addEventListener('click', () => {
            const maxPage = Math.ceil(allRows.length / rowsPerPage) - 1;
            if (currentPage < maxPage) {
                currentPage++;
                showCurrentPage();
            }
        });

        // Bouton retour au début
        document.querySelector('.nav-button.today').addEventListener('click', () => {
            currentPage = 0;
            showCurrentPage();
        });
        
        // Recalculer sur resize
        window.addEventListener('resize', () => {
            const oldRowsPerPage = rowsPerPage;
            calculateRowsPerPage();
            // Ajuster la page actuelle si nécessaire
            if (oldRowsPerPage !== rowsPerPage) {
                currentPage = 0;
                showCurrentPage();
            }
        });
    }
    
    /*
    * Limitation du nombre de lignes (partie droite - calendrier)
    * - calcule après chargement des polices et à chaque resize
    * - s'appuie sur la hauteur réelle du wrapper (flex:1)
    */
    const rightWrapper = document.querySelector('.screen-right .table-wrapper');
    const programTable = rightWrapper ? rightWrapper.querySelector('table.program-table') : null;

    function limitProgramRows() {
        if (!rightWrapper || !programTable) return;
        const tbodyRows = Array.from(programTable.querySelectorAll('tbody tr'));
        const thead = programTable.querySelector('thead');
        // réinitialiser l'affichage
        tbodyRows.forEach(r => (r.style.display = ''));

        const available = rightWrapper.clientHeight - (thead ? thead.offsetHeight : 0);
        let used = 0;
        for (const row of tbodyRows) {
            const h = row.offsetHeight;
            if (used + h <= available) {
                used += h;
            } else {
                row.style.display = 'none';
            }
        }
    }

    // Exécuter après chargement des polices (évite les mesures incorrectes sur TV/zoom)
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(limitProgramRows);
    } else {
        window.addEventListener('load', limitProgramRows);
    }
    // Recalcul sur resize et changement de devicePixelRatio (TV/projo)
    window.addEventListener('resize', limitProgramRows);
    const ro = new ResizeObserver(limitProgramRows);
    if (rightWrapper) ro.observe(rightWrapper);
    // Premier passage après DOM ready au cas où
    setTimeout(limitProgramRows, 0);
    
    console.log('ISFB Screen 5 - Planification roulante initialisé');
    
    /*
    * Auto-refresh toutes les 15 minutes
    */
    setInterval(function() {
        window.location.reload();
    }, 15 * 60 * 1000); // 15 minutes en millisecondes
});
